import { gql } from '@apollo/client';
import type { FleetCompanyContract, FleetCompanyContracts, FleetCompanyOnboardingStatus } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLFleetContractsRequester {
  public getFleetContracts = (fleetId: string): Promise<FleetCompanyContract[]> =>
    graphQLRequester
      .query<{ contracts: FleetCompanyContracts }>({
        query: gql`
          query contracts($fleetId: String!) {
            contracts(fleetId: $fleetId) {
              fleetId
              contracts {
                companyId
                companyStatus
                contractSignedDate
              }
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => result.contracts.contracts);

  public getFleetCompanyOnboardingStatus = (fleetId: string): Promise<FleetCompanyOnboardingStatus> =>
    graphQLRequester
      .query<{ companyOnboardingStatus: FleetCompanyOnboardingStatus }>({
        query: gql`
          query companyOnboardingStatus($fleetId: String!) {
            companyOnboardingStatus(fleetId: $fleetId) {
              hasAnyOnboardingContract
              hasAnyContractSignedInLast90Days
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => result.companyOnboardingStatus);
}

export default GraphQLFleetContractsRequester;
